import dayjs, { type Dayjs } from "dayjs"

/**
 * Compact "2h ago" rather than dayjs's "2 hours ago" — the density a Last
 * Activity column is drawn at. Shared by the Leads and Projects lists.
 */
export function shortRelativeTime(
  value: unknown,
  now: Dayjs = dayjs()
): string {
  if (!value) return ""
  const at = dayjs.isDayjs(value) ? value : dayjs(value as string)
  if (!at.isValid()) return ""

  const seconds = now.diff(at, "second")
  if (seconds < 0) return "just now"
  if (seconds < 60) return "just now"

  const minutes = Math.floor(seconds / 60)
  if (minutes < 60) return `${minutes}m ago`

  const hours = Math.floor(minutes / 60)
  if (hours < 24) return `${hours}h ago`

  const days = Math.floor(hours / 24)
  if (days < 30) return `${days}d ago`

  const months = Math.floor(days / 30)
  if (months < 12) return `${months}mo ago`

  return `${Math.floor(months / 12)}y ago`
}
